<div class="container-fluid">
    <form (ngSubmit)="getRemittances()"  *ngIf="!newData">

        <div class="row mt-3 animated fadeIn fadeOut">
            <div class="col-md-6">
                <mat-card>
                    <mat-card-title>
                        Consulta
                    </mat-card-title>
                    <mat-card-content>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <mat-form-field class="col-md-6">
                                        <mat-label>N° Protocolo</mat-label>
                                        <input matInput placeholder="" name="orderid">
                                    </mat-form-field>
                                    <mat-form-field class="col-md-6">
                                        <mat-label>Servicio</mat-label>
                                        <mat-select [(ngModel)]="filter.ward" name="ward">
                                            <mat-option [value]="all" default>
                                                Todos
                                            </mat-option>
                                            <mat-option [value]="filter.ward" default *ngIf="filter.ward">
                                                {{filter.ward.wardDescription}}
                                            </mat-option>
                                            <mat-option *ngFor="let ward of wards" [value]="ward">
                                                {{ward.wardDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="row">
                                    <mat-form-field class="col-md-3">
                                        <mat-label>Desde</mat-label>
                                        <input matInput (focus)="picker.open()" [(ngModel)]="filter.startDate"
                                            [matDatepicker]="picker" name="startDate">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="col-md-3">
                                        <mat-label>Hasta</mat-label>
                                        <input matInput (focus)="picker2.open()" [(ngModel)]="filter.endDate"
                                            [matDatepicker]="picker2" name="endDate">
                                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                        <mat-datepicker #picker2></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="col-md-6">
                                        <mat-label>Estado</mat-label>
                                        <mat-select [(ngModel)]="filter.ward" name="ward">
                                            <mat-option [value]="all" default>
                                                Todos
                                            </mat-option>
                                            <mat-option [value]="filter.ward" default *ngIf="filter.ward">
                                                {{filter.ward.wardDescription}}
                                            </mat-option>
                                            <mat-option *ngFor="let ward of wards" [value]="ward">
                                                {{ward.wardDescription}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>


                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-md-6">
                <mat-card>
                    <mat-card-content>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-3">
                                    <mat-checkbox [(ngModel)]="filter.user" name="user">Solo ingresadas por mí
                                    </mat-checkbox>

                                    <mat-checkbox class="example-margin"
                                    [checked]="filter.allComplete"
                                    [indeterminate]="filter.someComplete()"
                                    (change)="filter.setAll($event.checked)">
                                        Remitos
                                    </mat-checkbox>
                                    <ul class="remittance-list">
                                        <li>
                                            <mat-checkbox [(ngModel)]="filter.withRemittance" name="withRemittance"  (ngModelChange)="filter.updateAllComplete()">Con
                                            </mat-checkbox>
                                        </li>
                                        <li>
                                            <mat-checkbox [(ngModel)]="filter.withoutRemittance" name="withRemittance" (ngModelChange)="filter.updateAllComplete()">Sin
                                            </mat-checkbox>
                                        </li>
                                    </ul>

                                </div>
                            </div>

                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-12 text-center">
                <button mat-raised-button color="primary" class="mr-1" type="submit">
                    Buscar
                </button>
                <button mat-raised-button color="secondary" (click)="filter.clear(); $event.preventDefault();">
                    Limpiar
                </button>
            </div>

        </div>
    </form>

    <div class="row mt-3" *ngIf="newData">
        <div class="col-md-12 text-center">
            <button mat-raised-button color="primary" (click)="selection.clear(); newData = false;">
                Nueva búsqueda
            </button>
        </div>

    </div>

    <div class="row mt-3" *ngIf="newData">
        <div class="col-12">
            <mat-card>
                <mat-card-title>
                    Solicitudes
                </mat-card-title>
                <mat-card-content>
                    <mat-paginator [length]="remittances.length" [pageSize]="10" [pageSizeOptions]="['10','20','30']"
                        (page)="pageSize = $event.pageSize; pageIndex = $event.pageIndex; selectedRow = -1;">
                    </mat-paginator>

                    <div class="order-list-header">
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        [aria-label]="checkboxLabel()"
                                        class="check">
                        </mat-checkbox>
                        <span class="date ml-2">
                            Fecha
                        </span>
                        <span class="order">
                            N° Solicitud
                        </span>
                        <span class="name">
                            Paciente
                        </span>
                        <span class="age">

                        </span>
                        <span class="sex">

                        </span>
                        <span class="ward">
                            Servicios
                        </span>
                        <span class="actions">                            

                            <button mat-icon-button (click)="deleteOrders()"
                            [disabled]="selection.selected.length < 1">
                                <mat-icon>delete</mat-icon>
                            </button>         
                            
                            <button mat-icon-button [matMenuTriggerFor]="remitsMenu"
                            [disabled]="selection.selected.length < 1">
                                <mat-icon>mail_outline</mat-icon>
                            </button>
                            
                            <mat-menu #remitsMenu="matMenu" yPosition="above">
                                <button mat-icon-button (click)="createRemittance()">
                                    <mat-icon svgIcon="newRemittance">
                                    </mat-icon>                               
                                </button>

                                <button  mat-icon-button (click)="deleteRemittance()"
                                    [disabled]="canDeleteRemittance()">
                                    <mat-icon svgIcon="notRemitted">
                                    </mat-icon>                               
                                </button>                          
                                
                                <button mat-icon-button (click)="insertRemittance()"
                                [disabled]="canInsertRemittance()">
                                    <mat-icon svgIcon="remitted">
                                    </mat-icon>                               
                                </button>
                              </mat-menu>
                         
                           
                            
                            
                        </span>
                    </div>

                    <mat-accordion class="example-headers-align">
                        <mat-expansion-panel *ngFor="let element of orders; let i = index;" (afterExpand)="opened(i)"
                            (closed)="selectedRow = -1" hideToggle
                            [class.not-expanded]="selectedRow != i && selectedRow != -1">
                            <mat-expansion-panel-header>
                                <!--mat-panel-title>

                            </mat-panel-title-->
                                <mat-panel-description>
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(element) : null"
                                        [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)"
                                        class="check">
                                    </mat-checkbox>

                                    <span class="date ml-2">
                                        {{element.orderDate}}
                                    </span>

                                    <span class="order">
                                        <span class="order-badge" [matTooltip]="element.externalOrderId"
                                            [class.urgent-badge]="element.priorityLevel == 3">
                                            {{ element.orderId }}
                                        </span>
                                        <span>
                                            <button mat-icon-button disabled>
                                                <mat-icon class="doctor-icon ml-3" svgIcon="doctor"
                                                    [matTooltip]="element.doctor.nameSurname"></mat-icon>
                                            </button>
                                            <button mat-icon-button *ngIf="element.noteSector" disabled>
                                                <mat-icon class="note-icon ml-3" svgIcon="note"
                                                    [matTooltip]="element.noteSector"></mat-icon>
                                            </button>
                                        </span>

                                    </span>

                                    <!--span class="note">
                                        
                                    </span-->

                                    <span class="name">
                                        {{element.patient.name +' '+element.patient.surname}}
                                    </span>
                                    <span class="age" [matTooltip]="element.patient.birthdate">
                                        {{element.patient.age}}
                                    </span>
                                    <span class="sex" [class.icon-male]="element.patient.sex =='M'"
                                        [class.icon-female]="element.patient.sex =='F'">
                                    </span>


                                    <span class="ward">
                                        {{element.wardDescription + ' ' + element.orderState }}
                                    </span>

                                    <span class="actions">
                                        <button mat-icon-button
                                            (click)="deleteOrder(element); $event.stopPropagation();"
                                            [disabled]="selectedRow != i && selectedRow != -1">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                        <button mat-icon-button (click)="selectOrder(element)"
                                            [disabled]="selectedRow != i && selectedRow != -1">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button mat-icon-button [disabled]="selectedRow != i && selectedRow != -1">
                                            <mat-icon *ngIf="element.remittanceId != 0" svgIcon="remitted"
                                                (click)="deleteOrderFromRemittance(element); $event.stopPropagation();">
                                            </mat-icon>
                                            <mat-icon *ngIf="element.remittanceId == 0" svgIcon="notRemitted"
                                                (click)="insertOrderInRemittance(element); $event.stopPropagation();">
                                            </mat-icon>
                                        </button>

                                    </span>

                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <table class="table table-sm">

                                <tbody>
                                    <tr *ngFor="let sample of element.samples">
                                        <td class="align-middle">
                                            <mat-icon class="tube mr-3" svgIcon="logo"
                                                [matTooltip]="sample.containerDescription"></mat-icon>
                                            {{sample.labelId + ' ' + sample.sampleState}}
                                            <button mat-icon-button class="ml-3" *ngIf="sample.checkinDate != null"
                                                disabled>
                                                <mat-icon class="checkin-icon" [matTooltip]="sample.checkinDate"
                                                    matTooltipClass="checkin-tooltip">done</mat-icon>
                                            </button>
                                        </td>

                                        <td class="align-middle">
                                            <strong>{{sample.containerDescription}}</strong>
                                        </td>

                                        <td class="align-middle">
                                            <mat-chip-list>
                                                <mat-chip color="primary" *ngFor="let test of sample.tests"
                                                    [matTooltip]="test.description">{{test.id + ' ' + test.state}}
                                                </mat-chip>
                                            </mat-chip-list>
                                        </td>
                                        <td class="align-middle">
                                            <button mat-icon-button (click)="deleteSample(element, sample)"
                                                [disabled]="sample.checkinDate != null">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>

                        </mat-expansion-panel>

                    </mat-accordion>

                </mat-card-content>

            </mat-card>

        </div>
    </div>
</div>